export default "__VITE_ASSET__DxBpk2kg__"